import type { MediaView } from "./mediaTypes";

const urls = new Map<string, string>();
const views = new Map<string, MediaView>();
const urlFields = new Set(["mediaUrl", "mediaURL", "thumbnail", "thumbnailUrl", "thumbnailURL", "coverPhotoUrl", "productPhotoUrl", "additionalImageUrls"]);

export function registerMedia(view: MediaView): void {
  if (!view?.mediaId) return;
  views.set(view.mediaId, view);
  const reference = "hkp-media:" + view.mediaId;
  [view.masterUrl, ...(view.derivatives || []).map(image => image.url)].forEach(url => {
    if (url) { urls.set(url, reference); urls.set(url.split("?")[0], reference); }
  });
  while (urls.size > 10000) urls.delete(urls.keys().next().value!);
}

export function rememberMediaResponse<T>(value: T): T {
  if (!value || typeof value !== "object") return value;
  const response = value as any;
  if (response.mediaReferences) Object.values(response.mediaReferences).forEach(view => registerMedia(view as MediaView));
  return value;
}

/** Only media slots are rewritten. Signed URLs are delivery data, never a database identity. */
export function durableMediaWrites(value: any, key = ""): any {
  if (typeof value === "string") return urlFields.has(key) ? urls.get(value) || value : value;
  if (Array.isArray(value)) return value.map(item => durableMediaWrites(item, key));
  if (!value || typeof value !== "object" || value instanceof Blob || value instanceof Date) return value;
  return Object.fromEntries(Object.entries(value).map(([name, item]) => [name, durableMediaWrites(item, name)]));
}

export function mediaForUrl(url?: string): MediaView | undefined {
  // A durable "hkp-media:<id>" (a photo just uploaded, not yet saved and read back) resolves to its known view.
  const reference = url?.startsWith("hkp-media:") ? url : url ? urls.get(url) : undefined;
  return reference ? views.get(reference.slice("hkp-media:".length)) : undefined;
}

export function clearMediaReferences(): void { urls.clear(); views.clear(); }
